import { NavLink, Outlet } from "react-router-dom";
import { useAuth } from "@/lib/auth-context";

export default function Settings() {
  const { user } = useAuth();
  const isAdmin = user?.role === "admin" || user?.role === "owner";
  const isOwner = user?.role === "owner";

  const tabs = [
    { to: "/app/settings/profile", label: "Profile", show: true },
    { to: "/app/settings/billing", label: "Billing", show: isOwner },
    { to: "/app/settings/team", label: "Team", show: isAdmin },
    { to: "/app/settings/workspace", label: "Workspace", show: isAdmin },
    { to: "/app/settings/shared-links", label: "Shared links", show: true },
  ];

  return (
    <main className="flex-1 px-6 md:px-10 py-10" data-testid="settings-page">
      <p className="text-[11px] uppercase tracking-[0.28em] text-oxblood font-medium mb-2">— Settings</p>
      <h1 className="font-display text-3xl sm:text-4xl">Settings</h1>

      <nav className="mt-8 border-b border-border flex flex-wrap gap-1" data-testid="settings-tabs">
        {tabs.filter((t) => t.show).map((t) => (
          <NavLink key={t.to} to={t.to} end
            data-testid={`settings-tab-${t.label.toLowerCase().replace(/\s+/g, "-")}`}
            className={({ isActive }) =>
              `px-4 py-2.5 text-sm transition-colors -mb-px border-b-2 ${
                isActive
                  ? "border-oxblood text-oxblood font-medium"
                  : "border-transparent text-muted-foreground hover:text-foreground"
              }`}>
            {t.label}
          </NavLink>
        ))}
      </nav>

      <div className="mt-8 max-w-3xl">
        <Outlet context={{ isOwner, isAdmin }} />
      </div>
    </main>
  );
}
